import { useQuery } from "@tanstack/react-query";
import { PropsWithChildren, useEffect, useMemo, useState } from "react";
import { EditionContext } from "../contexts/edition";
import { Edition, EditionJson } from "../types";

export const EditionProvider = ({ ...props }: PropsWithChildren) => {
  const [edition, setEdition] = useState<Edition | null>(null)
  const [currentEdition, setCurrentEdition] = useState<Edition | null>(null);

  const { data: editions, isLoading } = useQuery<Edition[]>({
    queryKey: ["edition"],
    queryFn: async () => {
      const resp = await fetch("/api/edition");
      const data: EditionJson[] = await resp.json();
      return data.map(e => ({ id: e.id, start: new Date(e.start), end: new Date(e.end) }))
    },
    refetchOnWindowFocus: false
  });

  useEffect(() => {
    if (!editions || !editions.length) return

    const sorted = editions.sort((a, b) => b.start.getTime() - a.start.getTime())

    setCurrentEdition(sorted[0])
    setEdition(sorted[0])
  }, [editions])

  const value = useMemo(() => ({ edition, setEdition, currentEdition, isLoading }), [edition, setEdition, currentEdition, isLoading])

  return <EditionContext value={value} {...props} />
}
